<div class="modal-content modal-milvus">
    <div class="modal-header-milvus align-items-center">
        <div class="col-8 header-col">
            <span class="modal-title" *ngIf="create" [translate]="'NOVO_PERIODO'"></span>
            <span class="modal-title" *ngIf="!create" [translate]="'EDITAR_PERIODO'"></span>
        </div>
        <div class="col-4 header-col">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div class="modal-body" [formGroup]="periodoForm">
        <div class="row align-items-end">
            <div class="col-md-4 form-group" *ngIf="mostrarOperadorLogico">
                <label>Operador lógico</label>
                <select class="form-control" formControlName="operador_logico_id">
                    <option *ngFor="let operador of operadoresLogicos" [ngValue]="operador.id">{{operador.text}}</option>
                </select>
            </div>
            <div class="form-group" [ngClass]="mostrarOperadorLogico ? 'col-md-4' : 'col-md-6'">
                <label [translate]="'ENTIDADE'"></label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': periodoForm.controls.entidade_id.invalid && periodoForm.controls.entidade_id.touched}" [entidade]="'customContent'" [params]="entidadesFiltro" [model]="periodoForm.value.entidade_id" [required]="true" (selectChange)="periodoForm.patchValue({entidade_id: $event})"></select-padrao>
            </div>
            <div class="form-group" [ngClass]="mostrarOperadorLogico ? 'col-md-4' : 'col-md-6'">
                <label>Selecione o campo</label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': periodoForm.controls.campo_id.invalid && periodoForm.controls.campo_id.touched}" [entidade]="'selectCamposFiltros'" [customPlaceholder]="'CAMPO'" [model]="campoSelecionado" [required]="true" [returnObj]="true" [params]="fieldTypeEnum.Data" (selectChange)="patchCampoPeriodo($event)"></select-padrao>
            </div>
        </div>
        <div class="row align-items-end">
            <div class="col-md-6 form-group">
                <label>Selecione o operador</label>
                <select class="form-control" formControlName="operador_id" [ngClass]="{'required': periodoForm.controls.operador_id.invalid}">
                    <option [ngValue]="null">Selecione</option>
                    <option *ngFor="let operador of operadoresPeriodo" [ngValue]="operador.id">{{operador.text}}</option>
                </select>
            </div>
            <div class="col-md-6 form-group">
                <label>Dinâmico</label>
                <select class="form-control" formControlName="dinamico" (change)="changePeriodoDinamico()">
                    <option [ngValue]="false" [translate]="'NAO'"></option>
                    <option [ngValue]="true" [translate]="'SIM'"></option>
                </select>
            </div>
        </div>
        <div class="row align-items-end">
            <div class="col-md-12 form-group" *ngIf="periodoForm.value.dinamico">
                <label>Valor</label>
                <select-padrao [selectModalPequeno]="true" [ngClass]="{'required': tentouSalvar && !periodoForm.value.valor}" [entidade]="'selectDataDinamicaCondicaoFiltro'" [customPlaceholder]="'VALOR'" [model]="valorDinamicoSelecionado" [required]="true" [params]="'$datas'" [returnObj]="true" (selectChange)="patchDataDinamicaPeriodo($event)"></select-padrao>
            </div>
            <ng-container *ngIf="!periodoForm.value.dinamico">
                <div class="col-md-12 form-group" *ngIf="!isOperadorEntre()">
                    <label>Valor</label>
                    <input type="date" class="form-control" formControlName="valor" [ngClass]="{'required': tentouSalvar && !periodoForm.value.valor}">
                </div>
                <div class="col-md-6 form-group" *ngIf="isOperadorEntre()">
                    <label>Valor inicial</label>
                    <input type="date" class="form-control" formControlName="valor_inicio" [ngClass]="{'required': tentouSalvar && !periodoForm.value.valor_inicio}">
                </div>
                <div class="col-md-6 form-group" *ngIf="isOperadorEntre()">
                    <label>Valor final</label>
                    <input type="date" class="form-control" formControlName="valor_fim" [ngClass]="{'required': tentouSalvar && !periodoForm.value.valor_fim}">
                </div>
            </ng-container>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-success badge-pill" [disabled]="periodoForm.invalid || !periodoValorValido()" (click)="salvar()">
            <i class="mdi mdi-content-save-outline"></i>
            <span [translate]="'SALVAR'"></span>
        </button>
    </div>
</div>
